import React from 'react';
import CloseButton from '../CloseButton';
import Heading from '../Heading';
import { st, classes } from './MessageBoxFunctionalLayout.st.css.js';
import { dataHooks } from './constants';
import Box from '../Box';
const Header = ({ title, onCancel, theme = 'blue', closeButton = true, size = 'medium', newColorsBranding = false, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: st(classes.header, { theme, newColorsBranding }), "data-hook": dataHooks.header },
            React.createElement(Heading, { size: size, light: !newColorsBranding, className: classes.heading, dataHook: dataHooks.headerTitle }, title),
            closeButton && !newColorsBranding ? (React.createElement(CloseButton, { dataHook: dataHooks.headerCloseButton, size: newColorsBranding ? 'large' : 'medium', skin: newColorsBranding ? 'dark' : 'lightFilled', onClick: onCancel })) : null),
        closeButton && newColorsBranding ? (React.createElement(Box, { className: classes.controlButtons },
            React.createElement(CloseButton, { dataHook: dataHooks.headerCloseButton, size: newColorsBranding ? 'large' : 'medium', skin: newColorsBranding ? 'dark' : 'lightFilled', onClick: onCancel }))) : null));
};
export default Header;
//# sourceMappingURL=HeaderLayout.js.map